module.exports = __webpack_public_path__ + "static/img/logo-3.dcd1954a.png";